/**
 * Where to land after login (EU-756, OKR-003).
 *
 * The guard on `_authenticated` sends an anonymous visitor to `/login` carrying
 * the path they asked for; the LoginPage hands that path to Keycloak as the
 * `redirectUri`, so a deep link such as `/okrs` survives the round trip instead
 * of always dropping the consultor on the home page.
 *
 * The value travels in the URL, so it is untrusted. Only a same-origin,
 * absolute-path string is accepted: no scheme, no `//host`, no backslash tricks,
 * and never `/login` itself (which would loop). Anything else falls back to the
 * home page. Keycloak's own `redirectUris` allowlist is a second fence, but the
 * SPA should not rely on it to avoid becoming an open redirector.
 */
export const HOME_PATH = '/';

export function safeReturnPath(value: string | undefined | null): string | undefined {
  if (!value) return undefined;
  if (!value.startsWith('/')) return undefined;
  if (value.startsWith('//') || value.startsWith('/\\')) return undefined;
  if (/[\r\n\0]/.test(value)) return undefined;
  const pathOnly = value.split(/[?#]/, 1)[0] ?? '';
  if (pathOnly === '/login' || pathOnly.startsWith('/login/')) return undefined;
  return value;
}

/** Absolute URL for Keycloak's `redirectUri`, built on the current origin. */
export function loginRedirectUri(returnTo: string | undefined | null): string {
  return window.location.origin + (safeReturnPath(returnTo) ?? HOME_PATH);
}
